import React from 'react';

// Logo Option 1: Clean Text with Mountain Icon
export const LogoOption1 = ({ className = "h-16" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <div className="flex flex-col items-center justify-center">
      <svg className="w-12 h-12" viewBox="0 0 48 48" fill="none">
        <path d="M24 8L8 38H40L24 8Z" fill="#1e40af" stroke="#1e40af" strokeWidth="2"/>
        <path d="M24 8L16 24L24 20L32 24L24 8Z" fill="#3b82f6"/>
        <circle cx="24" cy="32" r="2" fill="white"/>
      </svg>
    </div>
    <div className="flex flex-col">
      <span className="text-2xl font-bold text-gray-900 leading-tight tracking-tight">
        MILE HIGH
      </span>
      <span className="text-base font-semibold text-blue-600 leading-tight">
        REVERSE MORTGAGE
      </span>
    </div>
  </div>
);

// Logo Option 2: Bold Text Only
export const LogoOption2 = ({ className = "h-16" }) => (
  <div className={`flex flex-col justify-center ${className}`}>
    <span className="text-3xl font-bold text-blue-600 leading-none tracking-tight">
      MILE HIGH
    </span>
    <span className="text-sm font-semibold text-gray-700 leading-tight tracking-wide">
      REVERSE MORTGAGE
    </span>
  </div>
);

// Logo Option 3: Modern Stacked Design
export const LogoOption3 = ({ className = "h-16" }) => (
  <div className={`flex items-center space-x-3 ${className}`}>
    <div className="bg-blue-600 rounded-lg p-2 flex items-center justify-center w-14 h-14">
      <div className="text-white font-bold text-center leading-tight">
        <div className="text-xl">MH</div>
        <div className="text-xs">RM</div>
      </div>
    </div>
    <div className="flex flex-col">
      <span className="text-xl font-bold text-gray-900 leading-tight">
        Mile High
      </span>
      <span className="text-sm text-blue-600 font-semibold leading-tight">
        Reverse Mortgage
      </span>
    </div>
  </div>
);

// Logo Option 4: Professional Serif Style
export const LogoOption4 = ({ className = "h-16" }) => (
  <div className={`flex items-center space-x-2 ${className}`}>
    <div className="border-l-4 border-blue-600 pl-3">
      <div className="flex flex-col">
        <span className="text-2xl font-bold text-gray-900 leading-tight" style={{ fontFamily: 'Georgia, serif' }}>
          Mile High
        </span>
        <span className="text-sm font-medium text-blue-700 uppercase tracking-widest leading-tight">
          Reverse Mortgage
        </span>
      </div>
    </div>
  </div>
);

// Logo Option 5: Simple & Modern
export const LogoOption5 = ({ className = "h-16" }) => (
  <div className={`flex items-center ${className}`}>
    <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white px-4 py-3 rounded-lg">
      <div className="text-xl font-bold leading-tight">MILE HIGH</div>
      <div className="text-xs font-medium leading-tight">Reverse Mortgage</div>
    </div>
  </div>
);
